import styled from 'styled-components'


export const Container = styled.div`
  display: flex;
  flex-direction: column;
    
    .skills {
        color: #000;
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 2rem;
        letter-spacing: 0.15px;
        text-align: left;
        margin: 1.5rem 0;
    }
    
    .submitButton {
        display: none;
    }
`

export const LabelContainer = styled.div`
    .label {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5rem;
        letter-spacing: 0.15px;
        text-align: left;
    }

    .description {
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1.25rem;
        letter-spacing: 0.4px;
        text-align: left;
    }`